<div class="stats-container">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div *ngFor="let stat of quickStatsData; let i = index" class="stats fade-in" (mousemove)="cursorPositon($event)">
		<div
			*ngIf="!currentVersion"
			class="stat-div"
			[ngClass]="{ 'stat-div-last': i === quickStatsData.length - 1 }"
			data-size="small"
		>
			<div class="tooltip-container" style="display: none">
				<div class="tooltip">
					{{ stat?.title }}
					<br />{{ stat?.secondaryTitle }}
					<ng-template ngIf="stat.tertiaryTitle"><br />{{ stat?.tertiaryTitle }}</ng-template>
				</div>
			</div>
			<div class="stats-title">{{ stat?.name }}</div>
			<hr />
			<div class="stats-desc">{{ stat.title }}</div>
			<div class="stats-desc legend-secondary-title" *ngIf="stat.secondaryTitle">{{ stat.secondaryTitle }}</div>
			<div class="stat-value" *ngIf="stat.value != ''; else elseBlock">
				<span class="percentage">
					<span *ngIf="stat.hasPercent; else noPercentBlock">
						<span *ngIf="stat?.value">
							<ng-container *ngIf="stat.isClickrate; else noClickRate">
								{{ stat.percent_value }}
							</ng-container>
							<ng-template #noClickRate>
								<ng-container *ngIf="stat.withClickrate; else withNoClickRate">
									{{ stat?.value | formatNumber }}
								</ng-container>
							</ng-template>
						</span>
					</span>
					<ng-template #noPercentBlock>
						{{ stat?.value | formatNumber }}
					</ng-template>
					<ng-template #withNoClickRate>
						{{ stat?.value | formatNumber }} &nbsp;|&nbsp;
						{{ stat.percent_value }}
					</ng-template>
				</span>
			</div>
			<ng-template #elseBlock>
				<span *ngIf="stat?.name" class="no-percentage"> No Data Available </span>
				<span *ngIf="!stat?.name" class="no-percentage"> </span>
			</ng-template>
		</div>
		<div
			*ngIf="currentVersion"
			class="stat-div stat-div-r10"
			[ngClass]="{ 'stat-div-last': i === quickStatsData.length - 1 }"
			data-size="small"
		>
			<div class="contents">
				<div class="stat-value" *ngIf="stat.value != ''; else elseBlock">
					<div class="formatted-number">{{ stat?.value | formatNumber }}</div>
					<div class="formatted-percent">{{ stat.percent_value }}</div>
				</div>
				<ng-template #elseBlock>
					<span *ngIf="stat?.name" class="no-percentage"> -- </span>
				</ng-template>
				<div class="r10-stats-title">{{ stat?.name }}</div>
			</div>
			<div *ngIf="!isR10" class="tooltip-container">
				<div class="tooltip">{{ stat?.title }}</div>
			</div>
			<div *ngIf="isR10" class="tooltip-container">
				<div class="tooltip" [innerHTML]="stat?.title"></div>
			</div>
		</div>
	</div>
</div>
